<div class="row">
  <div class="col-sm-12">
    <label class='fakelabel' [ngStyle]="mandatory && {'display': 'inline-block'}">{{labelInput}}</label> <span *ngIf="mandatory" class="mandatory">*</span>
  </div>
  <div class="col-sm-12" [ngStyle]="submitPending && {'opacity': '0.6'}">
    <label class="<div checkBoxRadio">
      <input type="checkbox" [(ngModel)]="objectReference" (change)="onReturn.emit(objectReference)" [disabled]="submitPending">
      <div class="slider"></div>
    </label>
    <span class="title-toggle">
      {{objectReference ? 'Si' : 'No'}}
    </span>
  </div>
</div>
